import { render } from "./CardUser.vue?vue&type=template&id=ff08de32"
import script from "./CardUser.vue?vue&type=script&lang=js"
export * from "./CardUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__